import React, { Component } from 'react';

// components
import ImagePart from './ImagePart';
import VideoPart from './VideoPart/';
import HtmlPart from './HtmlPart';

class CardBannerPart extends Component {

	constructor(props) {
		super(props);
		this.restartVideo = this.restartVideo.bind(this);
	}

	componentDidMount() {
		if (this.props.onRef) {
			this.props.onRef(this); // registers component on parent through callback
		}
	}

	restartVideo() {
		this.videoPart.restart();
	}

	renderOverLayText() {
		const { overlayText } = this.props;
		if (!overlayText) return null;
		return <HtmlPart htmlString={overlayText} extraClass="banner__text-part" />;
	}

	render() {
		const {
			imageSrc, imageAltText, onImageClick,
			imageHref,
			videoSrc = false, videoAltText,
		} = this.props;

		if (!imageSrc && !videoSrc) return null;

		return (
			<div className="c-card-banner">

				{this.renderOverLayText()}

				{
					videoSrc ? (
						<VideoPart
							videoUrl={videoSrc}
							fallbackImage={imageSrc}
							fallBackAlt={videoAltText || imageAltText}
							onRef={(ref) => { this.videoPart = ref; }}
							autoplay
						/>
					) : (
							<ImagePart
							  onClick={onImageClick}
								url={imageSrc}
								alt={imageAltText}
								href={imageHref}
							/>)
				}
			</div>
		);
	}
}

export default CardBannerPart;




// WEBPACK FOOTER //
// ./src/parts/CardBannerPart.js